import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import PropTypes from 'prop-types';

const StyledVerticalCenter = styled('div', {
  marginTop: '5%',
  marginBottom: '5%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyConent: 'center',
});

const CenterSpinner = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ProviderSelectDrawerLoadingSpinner = ({
  isLoading,
  ariaLoadingLabel,
}) => {
  return (
    <If condition={isLoading}>
      <StyledVerticalCenter>
        <CenterSpinner>
          <LoadingSpinner
            size='$md'
            isLoading={isLoading}
            ariaLoadingLabel={ariaLoadingLabel}
          />
        </CenterSpinner>
      </StyledVerticalCenter>
    </If>
  );
};

ProviderSelectDrawerLoadingSpinner.propTypes = {
  isLoading: PropTypes.bool,
  ariaLoadingLabel: PropTypes.string,
};

ProviderSelectDrawerLoadingSpinner.defaultProps = {
  isLoading: false,
  ariaLoadingLabel: '',
};
